<template>
  <div class="room-header-container">
    <div class="header-top">
      <div class="room-header">
        <div class="room-info">
          <div class="host-info">
            <div class="host-avatar">
              <img
                v-if="mainHost"
                :src="mainHost.avatar"
                alt="Host"
              />
            </div>
            <div class="room-details">
              <h1>{{ streamTitle }}</h1>
              <div class="room-id">
                {{ mainHost.name }}
              </div>
            </div>
          </div>
          <div class="room-actions">
            <button
              v-if="isUserTheMainHost"
              class="settings-btn"
              @click="$emit('settings')"
            >
              <svg
                class="settings-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="viewer-count">
        <i class="fas fa-user" />
        <span>{{ audienceCount }}</span>
      </div>

      <!-- Added Close Button -->
      <b-button
        variant="link"
        class="close-button"
        @click="emitClose"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 352 512"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.5c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z"/>
        </svg>
        <span class="sr-only">Close</span>
      </b-button>
    </div>
    <div class="header-bottom">
      <div
        v-if="primaryGoal"
        class="goal-progress"
      >
        <svg
          v-if="primaryGoal.goalType === 1"
          class="goal-icon gem-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="currentColor"
        >
          <path d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"/>
        </svg>

        <img
          v-else-if="false && primaryGoal.goalType === 2 && primaryGoal.giftProductCode"
          :src="getGiftImageUrl(primaryGoal.giftProductCode)"
          alt="Goal Gift"
          class="goal-icon gift-icon"
        />

        <div class="progress-bar">
          <div
            class="progress"
            :style="{ width: progressPercentage + '%' }"
          />
        </div>
        <div class="progress-text">
          <span>{{ primaryGoalCurrentValue }}/{{ primaryGoalTarget }}</span>
        </div>
      </div>
    </div>
    <!-- Hediye satışı kaldırıldı — hediye gönderenler listesi devre dışı
    <GiftGivers :givers="giftGivers" />
    -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { BButton } from 'bootstrap-vue'
import GiftGivers from './GiftGivers.vue'

export default {
  name: 'VoiceRoomHeader',

  components: {
    GiftGivers,
    BButton,
  },

  props: {
    roomId: {
      type: Number,
      required: true,
    },
    hostAvatar: {
      type: String,
      required: true,
    },
    giftGivers: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters('voiceRoom', [
      'streamTitle',
      'primaryGoal',
      'primaryGoalCurrentValue',
      'primaryGoalTarget',
      'audienceCount',
      'mainHost',
    ]),
    ...mapState('auth', {
      currentUserId: state => state.user?.identifier,
    }),

    isUserTheMainHost() {
      const mainHostId = this.mainHost?.id
      return !!this.currentUserId && !!mainHostId && this.currentUserId === mainHostId
    },

    progressPercentage() {
      const target = this.primaryGoalTarget || 1
      return (this.primaryGoalCurrentValue / target) * 100
    },
  },

  methods: {
    emitClose() {
      this.$emit('close-stream')
    },
    getGiftImageUrl(productCode) {
      if (!productCode) return ''
      const imageName = productCode.split('.').pop()
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/images/gifts/${imageName}.png`)
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-svg {
  fill: #DB32F6;
}
.room-header-container {
  position: relative; // Needed for absolute positioning of the close button
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  max-width: 100%;

  .header-top {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .room-header {
    background: linear-gradient(to right, #E91E63, #A644FB);
    border-radius: 50px;
    padding: 8px;
    width: auto;

    .room-info {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .host-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .host-avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid rgba(255, 255, 255, 0.3);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .room-details {
          h1 {
            font-size: 16px;
            margin: 0;
            font-weight: 600;
            color: white;
          }

          .room-id {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }

      .room-actions {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-left: 12px;
        margin-right: 4px;

        .settings-btn {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: none;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .viewer-count {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 6px;
    color: white;
    font-size: 14px;
    height: fit-content;
  }

  .header-bottom {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .goal-progress {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    padding: 4px 12px;
    border-radius: 20px;
    width: auto;
    min-width: 200px;
    position: relative;

    .goal-icon {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
    .gem-svg {
      color: #FF4081;
    }

    .gift-icon {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }

    .progress-bar {
      flex-grow: 1;
      height: 8px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      position: relative;
      overflow: hidden;

      .progress {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: #FF9500;
        border-radius: 10px;
        transition: width 0.3s ease;
      }
    }

    .progress-text {
      color: white;
      font-size: 12px;
      font-weight: 500;
      align-self: flex-start;
      margin-top: 4px;
      display: flex;
      align-items: center;
      gap: 4px;
      .text-icon {
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
      .gem-svg.text-icon {
         color: #FF9500;
      }
      .text-icon-gift {
         color: #FF9500;
      }
    }
  }

  // Added close button styles
  .close-button {
    position: absolute;
    top: 1rem; // Adjust if needed relative to header padding
    right: 1rem; // Adjust if needed relative to header padding
    z-index: 10;
    padding: 0.5rem;
    color: white;
    border: none;
    background: none;

    &:hover,
    &:focus {
      color: #ccc;
      background: none;
      box-shadow: none;
    }
  }
}

// Media Query for Mobile Layout Adjustments
@media (max-width: 767.98px) {
  .header-top {
    flex-wrap: nowrap; // Prevent wrapping of items
    gap: 8px;         // Reduce gap between items
    align-items: center; // Ensure vertical alignment
  }

  .room-header {
    padding: 6px; // Slightly reduce padding
    flex-shrink: 1; // Allow header to shrink if needed
    min-width: 0;   // Allow shrinking below intrinsic size
  }

  .room-info {
     // Prevent internal wrapping if still an issue
     // flex-wrap: nowrap;
  }

  .host-info {
     min-width: 0; // Allow shrinking
  }

  .room-details {
     overflow: hidden; // Hide overflow if title is too long
     white-space: nowrap; // Prevent title wrapping
     text-overflow: ellipsis; // Add ellipsis for long titles
     min-width: 50px; // Give it some minimum space
     flex-shrink: 1;

     h1 {
       font-size: 14px; // Slightly smaller title on mobile
     }
  }

  .viewer-count {
    padding: 6px 10px; // Reduce padding
    font-size: 12px;   // Slightly smaller font
    flex-shrink: 0; // Prevent viewer count from shrinking too much
  }

  .close-button {
    padding: 6px; // Adjust padding if needed
    flex-shrink: 0;
  }

  // Adjustments for goal progress might also be needed
  .header-bottom {
      // Styles if needed
  }
  .goal-progress {
     padding: 4px 8px;
     min-width: 150px; // Adjust min-width if needed
  }
}
</style>
